import React from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Footer from "../../components/footer/footer";

export default function Faq() {
  return (
    <div>
      <AboutHeader />

      <div class="page_title_section">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-lg-9 col-md-9 col-12 col-sm-8">
                <h1>FAQ </h1>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-4">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>FAQ </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inner_faq_wrapper fixed_portion float_left">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper heading_wrapper_dark dark_heading">
                <h4>FAQ section</h4>
                <h3>Frequently Asked Questions</h3>
              </div>
            </div>
          </div>
          <div id="accordion" role="tablist" class="inner_faq_section">
            <div class="row">
              <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingOne">
                    <h5 class="h5-md">
                      <a
                        data-toggle="collapse"
                        href="#collapseOne"
                        role="button"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Is treasure growth investment a registered company?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseOne"
                    class="collapse show"
                    role="tabpanel"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac1.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          Yes, treasure growth investment is a registered in
                          united state as <q>treasure growth investment</q>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingTwo">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseTwo"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        How does treasure growth investment earn profits for its
                        members?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseTwo"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac2.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          treasure growth investment is involved in cloud
                          mining, which enables our company to earn Bitcoins and
                          other currencies without mining hardware, software,
                          electricity, or bandwidth
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingThree">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseThree"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How can I register a new account?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseThree"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac3.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          To register a new account, simply click the “Register
                          New Account” button or “Sign Up” link and fill out the
                          required information.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="heading4">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapse41"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapse41"
                      >
                        What is the minimum and maximum amount for deposit?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapse41"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="heading4"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac1.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          There is no minimun and maximum amount you can invest,
                          Surely you can make deposit of any amount by several
                          deposits.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="heading7">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseT"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseT"
                      >
                        How long does it take for my deposit to be added?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseT"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="heading7"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac3.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          Your deposit is automatically added after 4/6 network
                          confirmations for cryptocurrencies but for PM and
                          payeer this be added as soon as you paid funds is
                          confirmed.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingeight">
                    <h5 class="h5-md">
                      <a
                        data-toggle="collapse"
                        href="#collapseeight"
                        role="button"
                        aria-expanded="true"
                        aria-controls="collapseeight"
                      >
                        How do I request a withdrawal?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseeight"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingeight"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac1.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          You can request a withdrawal by clicking the
                          “Withdraw” button after you have logged in the
                          member's area and entering the amount you want to
                          withdraw.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card_pagee" role="tab" id="headingthe">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapsethe"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapsethe"
                      >
                        Are there any withdrawal fees?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapsethe"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingthe"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac1.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>No, there are no fees for withdrawal.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingthey">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapsethey"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapsenine"
                      >
                        How long does it take for my withdrawal to be sent?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapsethey"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingthey"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac1.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          Your withdrawal is sent Instantly request is confirmed
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingnine">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapsenine"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapsenine"
                      >
                        How can I change my account e-mail?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapsenine"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingnine"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac2.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          For security reasons, we do not allow users to change
                          their e-mail after registration. If you would like to
                          change your e-mail, please contact our support and we
                          will change it for you.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingTen">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseTen"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseTen"
                      >
                        Can I register multiple accounts from the same computer?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseTen"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingTen"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac3.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          Yes, you can register multiple accounts from the same
                          computer or IP address, but they cannot be your
                          referral.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingele">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapseele"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseele"
                      >
                        How can I contact your support?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapseele"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingele"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac1.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          You can contact our support through clicking the
                          “Contact Us” link. We offer support through Contact
                          Form, and E-mail or by clicking the chat button
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card_pagee" role="tab" id="headingtwe">
                    <h5 class="h5-md">
                      <a
                        class="collapsed"
                        data-toggle="collapse"
                        href="#collapsetew"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapsetew"
                      >
                        Can I Change My Transaction Pin?
                      </a>
                    </h5>
                  </div>

                  <div
                    id="collapsetew"
                    class="collapse"
                    role="tabpanel"
                    aria-labelledby="headingtwe"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="card_img">
                        <img src="images/ac3.jpg" alt="img" />
                      </div>
                      <div class="card_cntnt">
                        <p>
                          Yes, To change your transaction pin navigate to
                          account settings and click on change Pin.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div class="contact_section float_left">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper heading_wrapper_dark dark_heading">
                <h4>answers</h4>
                <h3>Did not find the answer?</h3>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <form>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <div class="form-pos">
                          <div class="form-group i-name">
                            <input
                              type="text"
                              class="form-control require"
                              name="full_name"
                              required=""
                              id="namTen-first"
                              placeholder="Name*"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12 col-md-12">
                        <div class="form-e">
                          <div class="form-group i-email">
                            <label class="sr-only">Email </label>
                            <input
                              type="email"
                              class="form-control require"
                              name="email"
                              required=""
                              id="emailTen"
                              placeholder=" Email*"
                              data-valid="email"
                              data-error="Email should be valid."
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12 col-md-12">
                        <div class="form-s">
                          <div class="form-group i-subject">
                            <input
                              type="text"
                              class="form-control"
                              name="subject"
                              required=""
                              id="subjectTen"
                              placeholder="Question*"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-m">
                          <div class="form-group i-message">
                            <textarea
                              class="form-control require"
                              name="message"
                              required=""
                              rows="4"
                              id="messageTen"
                              placeholder="Message"
                            ></textarea>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="tb_es_btn_div">
                          <div class="response"></div>
                          <div class="tb_es_btn_wrapper conatct_btn2">
                            <button type="button" class="submitForm">
                              send message !
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
}
